module.exports = __webpack_public_path__ + "img/company_intro.2c2b69e2.png";